module.exports = __webpack_public_path__ + "img/BMW-IX3.5316400e.webp";